import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "references-index-pane iodine-no-scroll-y full-height flex-grow-1 flex-shrink-0" }
const _hoisted_2 = {
  key: 0,
  class: "reference-index-container iodine-padding-md"
}
const _hoisted_3 = {
  key: 1,
  class: "references-embedded-index-container iodine-padding-md"
}

import ReferencesHeader from 'components/references/ReferencesHeader.vue';
import ReferencesSearch from 'components/references/ReferencesSearch.vue';
import ReferencesBrowse from 'components/references/ReferencesBrowse.vue';
import { ReferencesBook } from 'src/services/TrucodeReferencesService';
import {ReferencesHistoryData, ReferencesHistoryService} from 'src/services/ReferencesHistoryService';
import {ref} from 'vue';
import { useGrouperStore } from 'stores/GrouperStore';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesIndex',
  emits: ["articleChanged"],
  setup(__props, { emit: __emit }) {

const referencesOption = ref('search');
function optionChanged(value) {
    referencesOption.value = value;
}

function bookChanged(book : ReferencesBook) {
    console.log(book);
}

function onArticleChanged(value : string) {
    console.log('onArticleChanged' + value);
    const data : ReferencesHistoryData = {
        bookCode: 'AHA_CODING_HANDBOOK',
        bookDescription: 'AHA Coding Handbook',
        articleId: value,
        articleDescription: 'TUBERCULOSIS',
        searchTerm: 'sepsis',
    };
    ReferencesHistoryService.getInstance().addToHistory(data);
    emit('articleChanged', data);
}

const emit = __emit

let mode = useGrouperStore().layoutMode;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReferencesHeader, {
      onReferencesOptionChanged: optionChanged,
      onBookChanged: bookChanged
    }),
    (_unref(mode) == _unref(GrouperLayoutMode).fullScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (referencesOption.value === 'browse')
            ? (_openBlock(), _createBlock(ReferencesBrowse, {
                key: 0,
                onArticleChanged: onArticleChanged
              }))
            : _createCommentVNode("", true),
          (referencesOption.value === 'search')
            ? (_openBlock(), _createBlock(ReferencesSearch, {
                key: 1,
                onArticleChanged: onArticleChanged
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(mode) == _unref(GrouperLayoutMode).consolidated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (referencesOption.value === 'browse')
            ? (_openBlock(), _createBlock(ReferencesBrowse, {
                key: 0,
                onArticleChanged: onArticleChanged
              }))
            : _createCommentVNode("", true),
          (referencesOption.value === 'search')
            ? (_openBlock(), _createBlock(ReferencesSearch, {
                key: 1,
                onArticleChanged: onArticleChanged
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})